/**
 * @file
 * Placeholder file for custom sub-theme behaviors.
 *
 */
(function ($, Drupal) {

  /**
   * @type {{attach: Drupal.behaviors.faqList.attach}}
   */
  Drupal.behaviors.faqList = {
    attach: function (context, settings) {
      // Initialisatino du faq filter.
      $contextFaqFilter = $(context).find('#faq-filter');
      if ($contextFaqFilter.length) {
        this.initFaqFilter($contextFaqFilter)
      }

      // Initialisation du display.
      this.initFieldsetDisplay(context)
    },

    /**
     * INitialisation du faq filter (select de formulaire);
     * @param $faqFilter
     */
    initFaqFilter: function ($faqFilter) {
      // Initialisation de la taille du faqFIlter
      $faqFilter.width($faqFilter.width() * 1.2);
      // Event au changement de valeur
      $faqFilter.change(function () {
        Drupal.behaviors.faqList.onFaqFilterChanged(($(this)))
      })
      // Event à l'initiaalisation de la valeur.
      if( window.location.hash.length < 1 ){
        this.onFaqFilterChanged($faqFilter)
      }
    },

    /**
     * Action au changemetn de valeur depuis le faqfilter.
     *
     * On change uniquement le hash et on demande un update du display des fieldset.
     * @param $faqFilter
     */
    onFaqFilterChanged: function ($faqFilter) {
      window.location.hash = $faqFilter.val();
      this.initFieldsetDisplay(null);
    },

    /**
     * Update du fieldset à afficher en fonction du hash uniquement.
     *
     * @param context
     */
    initFieldsetDisplay: function (context) {
      var $faqWrapper = $(".faq-wrapper");

      if ($faqWrapper.length) {
        var hash = window.location.hash.slice(1);
        if (hash) {
          // Présélection du faqFilter
          var $option = $("#faq-filter option[value='" + hash + "']");
          if ($option.length) {
            $option.attr("selected", true);
          }

          // Affichage du bon formulaire en fonction du hash.
          $faqWrapper.addClass("hidden");
          $(".webform-wrapper").addClass("hidden");
          $(".q-and-a--wrapper").removeClass("hidden");
          $("#faq-" + hash).removeClass("hidden");
          $("[name='email_subject']").val($("#faq-filter option:selected").text());
        }

        // Ajout du hash dans le action des formulaires pour afficher le bon form après soumission.
        $faqWrapper.find('form').each(function (i, n) {
          var $form = $(n),
            action = $form.attr('action').split('#')[0];
          $form.attr('action', action + window.location.hash)
        });

        // Si on est sur un retour ajax de formulaire, on affiche le formulaire.
        if (context && typeof context.tagName !== "undefined" && context.tagName.toLowerCase() === 'form') {
          $("#faq-" + hash + " .webform-wrapper").removeClass('hidden')
          $("#faq-" + hash + " .q-and-a--wrapper").addClass('hidden')
        }
      }
    }
  };
})
(jQuery, Drupal);
